<template>
  <div>
  <b-container>
    
    <form @submit.prevent="login">
        <b-row class="justify-content-md-center" align-h="center">
          <b-col cols="12" sm="10" md="4">
            <h2>Login</h2>
            <b-alert :show="$route.query.redirect" variant="info">You need to login first.</b-alert>
            <b-alert :show="error_msg != null" variant="danger">{{error_msg}}</b-alert>
            <b-form-group>
              <b-form-input v-model="loginText"
                
                type="text"
                placeholder="Username or Email">
              </b-form-input>
            </b-form-group>
            <b-form-group>
              <b-input-group>
                <b-form-input v-model="pass" v-show="!showPassword"
                    type="password"
                    placeholder="Password">
                </b-form-input>
                <b-form-input v-model="pass" v-show="showPassword"
                    type="text"
                    placeholder="Password">
                </b-form-input>
                <b-input-group-append>
                  <b-btn variant="secondary" @click="toggleShowPassword">
                    <icon v-show="showPassword" scale="1" name="eye-slash"></icon>
                    <icon v-show="!showPassword" scale="1" name="eye"></icon>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-button type="submit" variant="primary" >Login</b-button>
            </b-form-group>
            <b-link href="#/reset_password">Forgot Password?</b-link>
          </b-col>
        </b-row>
      </form>
    </b-container>
  </div>
</template>
<script>
  import api from '../api'
  export default {
    data () {
      return {
        loginText: '', //the username or email
        pass: '',
        error_msg: null,
        loading: false,
        showPassword: false
      }
    },
    methods: {
      toggleShowPassword () {
          this.showPassword = !this.showPassword 
      },
      login () {
        this.loading = true
        this.error = false
        api.login(this.loginText, this.pass)
          .then(response => {
            this.loading = false
            this.$router.replace(this.$route.query.redirect || '/')
          }).catch(error => {
            console.log(error)
            if(error.response.status == 401 && error.response.data.ret_msg == undefined) {
              this.error_msg = 'Incorrect username or password'
            } else {
              this.error_msg = error.response.data.ret_msg || "An unknown error occurred "
            }
            this.loading = false
          })
      }
    }
  }
</script>

<style>
  .error {
    color: red;
  }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue